module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//1.jpg?41362a7f8c8a6192b861129ccda620e7";